<template>
    <el-dialog
        :title="title"
        :visible.sync="defentArrDialogVisible"
        width="1000px"
        @close="closeDialog"
        :close-on-click-modal="false"
        :destroy-on-close="true"
        class="leader-dialog"
    >
        <div style="height: 500px;">
            <!-- <el-scrollbar style="height: 100%; width: 100%"> -->
            <el-form
                class="leader-style-form"
                :rules="arrangeDefentForm"
                :model="arrangeDefentForm"
                ref="arrangeDefentForm"
            >
                <el-row :gutter="20">
                    <el-col :span="11">
                        <el-form-item label="设备名称" :label-width="labelWidth">
                            <el-input disabled v-model="arrangeDefentForm.tree_name"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="缺陷来源" :label-width="labelWidth">
                            <el-select
                                disabled
                                v-model="arrangeDefentForm.defect_source"
                                style="width: 100%"
                            >
                                <el-option
                                    v-for="item in defectSource"
                                    :key="item.code_value"
                                    :label="item.code_name"
                                    :value="item.code_value"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="11">
                        <el-form-item label="缺陷性质" :label-width="labelWidth">
                            <el-select
                                disabled
                                v-model="arrangeDefentForm.defect_level"
                                style="width: 100%"
                            >
                                <el-option
                                    v-for="item in defectLevels"
                                    :key="item.code_value"
                                    :label="item.code_name"
                                    :value="item.code_value"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="缺陷发现人" :label-width="labelWidth">
                            <el-input disabled v-model="arrangeDefentForm.founder"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="11">
                        <el-form-item label="联系电话" :label-width="labelWidth">
                            <el-input
                                disabled
                                maxlength="50"
                                v-model="arrangeDefentForm.founder_phone"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="缺陷发现日期" :label-width="labelWidth">
                            <el-date-picker
                                disabled
                                v-model="arrangeDefentForm.found_time"
                                type="date"
                                placeholder="选择日期"
                                :default-value="timeNow"
                                value-format="yyyy-MM-dd"
                                format="yyyy-MM-dd"
                                style="width: 100%"
                                :picker-options="pickerOptions"
                            ></el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="23">
                        <el-form-item
                            label="缺陷内容"
                            style="width: 100%;"
                            prop
                            :label-width="labelWidth"
                        >
                            <el-input
                                disabled
                                type="textarea"
                                rows="2"
                                v-model="arrangeDefentForm.defect_content"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="23">
                        <el-form-item label="缺陷图片" :label-width="labelWidth">
                            <el-upload
                                disabled
                                class="avatar-uploader"
                                action
                                multiple
                                :http-request="uploadFile"
                                list-type="picture-card"
                                :file-list="fileImgs"
                                accept=".jpg, , jpeg, .png, .gif, .bmp"
                            >
                                <i class="el-icon-plus"></i>
                            </el-upload>
                        </el-form-item>
                    </el-col>

                    <!-- <el-col :span="12">
                            <el-form-item
                                label="消缺结果"
                                :label-width="labelWidth"
                            >
                                <el-radio-group class="leader-style-radio">
                                    <el-radio label="10">已消缺</el-radio>
                                    <el-radio label="20">未消缺</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item
                                label="消缺处理方式"
                                :label-width="labelWidth"
                                ><el-input></el-input
                            ></el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item
                                label="消缺开始时间"
                                :label-width="labelWidth"
                            >
                                <el-date-picker
                                    type="date"
                                    placeholder="选择日期"
                                    :default-value="timeNow"
                                    value-format="yyyy-MM-dd"
                                    format="yyyy-MM-dd"
                                    :picker-options="pickerOptions"
                                ></el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item
                                label="消缺结束时间"
                                :label-width="labelWidth"
                            >
                                <el-date-picker
                                    type="date"
                                    placeholder="选择日期"
                                    :default-value="timeNow"
                                    value-format="yyyy-MM-dd"
                                    format="yyyy-MM-dd"
                                    :picker-options="pickerOptions"
                                ></el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item
                                label="消缺负责人"
                                :label-width="labelWidth"
                                ><el-input></el-input
                            ></el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item
                                label="缺陷图片"
                                :label-width="labelWidth"
                            >
                                <el-upload
                                    class="avatar-uploader"
                                    action
                                    multiple
                                    :http-request="uploadFile"
                                    list-type="picture-card"
                                    :file-list="fileImgs"
                                    :on-remove="handleRemove"
                                    accept=".jpg, , jpeg, .png, .gif, .bmp"
                                >
                                    <i class="el-icon-plus"></i>
                                </el-upload>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item
                                label="消缺过程描述"
                                style="width: 100%;"
                                prop=""
                                :label-width="labelWidth"
                            >
                                <el-input type="textarea" rows="4"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item
                                label="其他说明"
                                style="width: 100%;"
                                prop=""
                                :label-width="labelWidth"
                            >
                                <el-input type="textarea" rows="2"></el-input>
                            </el-form-item>
                    </el-col>-->
                </el-row>
            </el-form>
            <!-- </el-scrollbar> -->
        </div>
        <div slot="footer" class="dialog-footer">
            <!-- <el-button class="leader-common-button">转巡检</el-button>
            <el-button class="leader-common-button">转检修</el-button>-->

            <!-- <el-button class="leader-common-button">撤销作废</el-button> -->
            <el-button @click="defentArrDialogVisible = false" class="leader-common-button">关闭</el-button>
            <el-button type="primary" @click="deleteDefectById()" class="leader-common-button">作废</el-button>
        </div>
    </el-dialog>
</template>
<script>
import * as api from '../../api/index';
export default {
    props: {
        title: {
            type: String,
            default: '缺陷安排',
        },
        defentArrDialogVisible: {
            type: Boolean,
            default: false,
        },
        defect_id: {
            type: String,
        },
    },
    watch: {
        defentArrDialogVisible(newVal) {
            if (newVal) {
                this.getDefectSource();
                this.getDefectLevel();
            }
        },
        defect_id(newVal) {
            if (newVal) {
                this.defect_id = newVal;
                this.getDefectById();
            }
        },
    },

    data() {
        return {
            labelWidth: '140px',
            arrangeDefentForm: {
                tree_name: '',
                defect_source: '', //缺陷来源
                defect_level: '', //缺陷性质
                founder: '',
                founder_phone: '',
                found_time: '',
                defect_content: '',
            },
            defectSource: [],
            defectLevels: [],
            fileImgs: [],
        };
    },
    created() {
        this.fileImgs = [];
    },
    methods: {
        //获取缺陷来源
        getDefectSource() {
            api.getCodelistByKind({
                code_kind: 'defect_source',
            }).then((res) => {
                if (res) {
                    this.defectSource = res.bus_json[0].codelists;
                }
            });
        },
        //获取缺陷性质
        getDefectLevel() {
            api.getCodelistByKind({
                code_kind: 'defect_level',
            }).then((res) => {
                if (res) {
                    this.defectLevels = res.bus_json[0].codelists;
                }
            });
        },
        getDefectById() {
            api.getDefectById({
                defect_id: this.defect_id,
            }).then((res) => {
                if (res) {
                    this.arrangeDefentForm = { ...res.bus_json };
                    if (res.bus_json.qx_file_list) {
                        this.fileImgs = [];
                        res.bus_json.qx_file_list.forEach((item) => {
                            this.fileImgs.push({
                                file_id: item.file_id,
                                url:
                                    process.env.VUE_APP_3D_URL +
                                    '/' +
                                    item.file_path,
                            });
                        });
                    }
                    // this.defentCheckForm.qx_file_list =
                    //     res.bus_json.qx_file_list;

                    // if (res.bus_json.qx_file_list) {
                    //     res.bus_json.qx_file_list.forEach(item => {
                    //         this.qxFileImgs.push({
                    //             file_id: item.file_id,
                    //             url: item.file_path
                    //         });
                    //     });
                    // }
                }
            });
        },
        deleteDefectById() {
            api.deleteDefectById({
                defect_id: this.defect_id,
            }).then((res) => {
                if (res) {
                    this.$message({
                        type: 'success',
                        message: res.error_msg,
                    });
                    this.defentArrDialogVisible = false;
                    this.$emit('updateBeginData');
                }
            });
        },
        closeDialog() {
            this.defentArrDialogVisible = false;
            this.$emit(
                'update:defentArrDialogVisible',
                this.defentArrDialogVisible
            );
        },
    },
};
</script>
<style lang="scss">
.defentArrDialogClass {
    .el-dialog {
        // height: 600px;
        .el-dialog__body {
            height: 100%;
            padding: 20px !important;
        }
    }
    .avatar-uploader {
        text-align: left;
        .el-upload--picture-card {
            width: 100px;
            height: 100px;
            line-height: 100px;
        }
        .el-upload-list--picture-card .el-upload-list__item {
            width: 100px;
            height: 100px;
        }
    }
}
</style>
